import { useStartAPetitionPageFcmExperiments } from 'src/app/pages/startAPetition/pageContext';

export function useSunriseRethemeExperiment(): { enabled: boolean } {
	const experiments = useStartAPetitionPageFcmExperiments();

	return { enabled: experiments.sunriseRethemeToggle.variation === 'enabled' };
}
